export default "__VITE_ASSET__c9054079__"